module.exports = __webpack_public_path__ + "static/media/webchat-new.3cdc9a01.svg";